import { EventsThemeBadge } from "@faire/retailer-visitor-shared/components/Events/shared/EventsThemeBadge";
import { BadgeGuidepost } from "@faire/retailer-visitor-shared/components/ProductBadge/BadgeGuidepost";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { IBadge } from "@faire/web-api--source/indigofair/badges/IBadge";
import * as React from "react";
import styled from "styled-components";

interface IProps {
  favoriteButton?: React.ReactNode;
  showEventBadge?: boolean;
  tileBadge?: IBadge;
  productToken?: string;
  onTopLeftBadgeVisible?: (tileBadge?: IBadge) => void;
  hideDetails?: boolean;
}

export const TopBadges: React.FC<IProps> = (props) => {
  const badgeGuidepostRef = useDoActionWhenVisible(() =>
    props.onTopLeftBadgeVisible?.(props.tileBadge)
  );

  const { productToken, showEventBadge } = props;

  const tileBadge = props.tileBadge ? (
    <div ref={badgeGuidepostRef} key="tile-badge">
      <BadgeGuidepost badge={props.tileBadge} productToken={productToken} />
    </div>
  ) : null;
  const favoriteBadge = isLoggedInRetailer() ? props.favoriteButton : null;

  if ((tileBadge || favoriteBadge) && !props.hideDetails) {
    return (
      <>
        <TopBadgesContainer
          key="top-badges-container"
          $showEventBadge={showEventBadge}
        >
          <HideContainer $showEventBadge={showEventBadge}>
            <LeftElementContainer>{tileBadge}</LeftElementContainer>
          </HideContainer>
          <div>{favoriteBadge}</div>
        </TopBadgesContainer>
        {showEventBadge ? <StyledEventsThemeBadge expandable /> : null}
      </>
    );
  }
  if (showEventBadge) {
    return <StyledEventsThemeBadge expandable />;
  }
  return null;
};

const LeftElementContainer = styled.div`
  max-width: 100%;
`;

const TopBadgesContainer = styled(Row).attrs({
  align: "flex-start",
  justify: "space-between",
})<{ $showEventBadge?: boolean }>`
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 2;
  padding: ${({ $showEventBadge: showEventBadge }) =>
    showEventBadge ? getSpacing(14, "1x", "1x", "7x") : getSpacing(4)};
`;

const StyledEventsThemeBadge = styled(EventsThemeBadge)`
  position: absolute;
  top: ${getSpacing(10)};
  left: ${getSpacing(10)};
  z-index: 2;
`;

interface IHideContainer {
  $showEventBadge?: boolean;
}

const HideContainer = styled.div<IHideContainer>`
  max-width: 80%;
  min-width: 0;
  padding: ${(props) => (props.$showEventBadge ? "0px" : "4px")};
`;
